module.exports = __webpack_public_path__ + "img/discord01.8de670e.jpg";